import React from 'react';
import PropTypes from 'prop-types';
import { Widget } from 'react-typeform-embed';
import { ENTERED, EXITING } from 'react-transition-group/Transition';

import TouchBlocker from '../shared/TouchBlocker';
import utils from '../../../../common/utils';
import fabric from '../../../../common/fabric';

/**
 * Typeform component
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const Typeform = props => {
  const {
    params,
    style,
    groupAngle,
    groupOpacity,
    matrixGroup,
    globalScale,
  } = props;
  const { shadow } = params;

  const objectMatrix = params.ludus.transformMatrix;

  const nonScaledObjMatrix = [
    1,
    objectMatrix[1],
    objectMatrix[2],
    1,
    objectMatrix[4],
    objectMatrix[5],
  ];
  const transformMatrix = matrixGroup
    ? fabric.util.multiplyTransformMatrices(matrixGroup, nonScaledObjMatrix)
    : nonScaledObjMatrix;

  const slideMatrix = fabric.util.multiplyTransformMatrices(
    [globalScale, 0, 0, globalScale, 0, 0],
    transformMatrix,
  );

  const blockStyles = {
    ...style,
    top: 0,
    left: 0,
    width: params.width * params.scaleX,
    height: params.height * params.scaleY,
    transform: `translate(-50%, -50%) matrix(${slideMatrix})`,
    transformOrigin: 'center center',
    opacity: groupOpacity,
    backgroundColor: 'transparent',
    overflow: 'hidden',
    boxShadow: shadow
      ? utils.getBoxShadowFromFabricShadow(shadow, groupAngle, 1)
      : 'none',
  };
  const blockInnerStyles = {
    position: 'absolute',
    width: '100%',
    height: '100%',
  };

  return (
    <TouchBlocker
      style={blockStyles}
      enabled={utils.isMobileDevice()}
      windowHasFocus={props.windowHasFocus}
    >
      <div>
        {[ENTERED, EXITING].includes(props.transitionStatus) && (
          <Widget
            id={props.params.ludus?.url?.split?.('/').pop() || ''}
            style={blockInnerStyles}
            hideHeaders={props.params.ludus.hideHeaders}
            hideFooter={props.params.ludus.hideFooter}
            opacity={props.params.ludus.backgroundOpacity}
            disableAutoFocus
          />
        )}
      </div>
    </TouchBlocker>
  );
};

Typeform.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  windowHasFocus: PropTypes.bool.isRequired,
  groupAngle: PropTypes.number.isRequired,
  groupOpacity: PropTypes.number.isRequired,
  transitionStatus: PropTypes.string.isRequired,
  matrixGroup: PropTypes.arrayOf(PropTypes.number),
  globalScale: PropTypes.number,
};
Typeform.defaultProps = {
  showLoader: true,
  matrixGroup: null,
  globalScale: 1,
};

export default Typeform;
